import cookie from '../utils/cookie';
import mixUtil from '../utils/util';

// 点击节流, 防止多次打开activety
let throttle_timer = null;

let app = {
    data() {
        return {
            updateVipSelectRow: {},
            // 会员介绍页面季度和年度会员价格
            introduceObj: {
                annual: '',
                quarterly: '',
                currencyType: ''
            },
        }
    },
    methods: {
        throttleClickItem(fn, wait=500) {
            if (!throttle_timer) {
                throttle_timer = setTimeout(() => {
                    throttle_timer = null;
                    fn.apply(this, arguments);
                }, wait);
            }
        },
        goActive(opt) {
            if(this.$config.envType === 'app') {
                opt.appCallback && opt.appCallback();
            } else if(this.$config.envType === 'h5') {
                opt.webCallback && opt.webCallback();
            }
        },
        queryUpdateVipGoods() {
            let channelType = window.dsBridge.call('getChannelType') || 'APP';
            this.$http.post({
                url: this.$api.queryOfferList,
                data: {
                    goodsType: 'COMM',
                    categoryCode: 'MBCP',
                    channelType
                }
            }).then(res => {
                if(res.data && res.data.dataList && res.data.dataList.length > 0) {

                    let introduceObjCurrencyType = '';
                    let annuals = [];
                    let quarterlys = [];

                    res.data.dataList.forEach(row => {
                        introduceObjCurrencyType = row.currencyType;
                        if(row.payAgreeFlag == "1" && row.deductionInfo != null && row.deductionInfo.autoRenewActCode != null) {
                            let autoRenewFirstPrice = row.deductionInfo.autoRenewFirstPrice ? row.deductionInfo.autoRenewFirstPrice : 0.0;
                            if(autoRenewFirstPrice > 0 && autoRenewFirstPrice < row.goodsPrice) {
                                row.goodsPriceText = mixUtil.keepTwodecimalFull(autoRenewFirstPrice/100);
                                row.listPrice = mixUtil.keepTwodecimalFull(row.goodsPrice/100);
                            } else {
                                row.goodsPriceText = mixUtil.keepTwodecimalFull((row.discountPrice != null ? row.discountPrice : row.goodsPrice)/100);
                            }
                        } else {
                            row.goodsPriceText = mixUtil.keepTwodecimalFull((row.discountPrice != null ? row.discountPrice : row.goodsPrice)/100);
                            if(row.discountPrice != null) {
                                row.listPrice = mixUtil.keepTwodecimalFull(row.goodsPrice/100);
                            }
                        }

                        if(row.periodUnit == 'MONTH') {
                            if(row.period == 12) {
                                row.periodText = '1';
                                row.periodUnitText = this.$t('order.periodUnit.year');
                                row.priceOfMonth = mixUtil.keepTwodecimalFixed(row.goodsPriceText / 12);
                                annuals.push(row) // 年度会员
                            } else {
                                row.periodText = row.period;
                                if(row.period > 1) {
                                    row.periodUnitText = this.$t('order.periodUnits.month');
                                } else {
                                    row.periodUnitText = this.$t('order.periodUnit.month');
                                }
                                row.priceOfMonth = mixUtil.keepTwodecimalFixed(row.goodsPriceText / row.period);

                                if(row.period == 3) {
                                    quarterlys.push(row); // 季度会员
                                }
                            }
                        }
                    });
                    /*
                    * 计算会员介绍页面的季度和年度会员的价格
                    * */
                    if(quarterlys.length) {
                        quarterlys.sort((a, b) => {
                            return b.goodsPriceText*1 - a.goodsPriceText*1;
                        });
                        this.introduceObj.quarterly = quarterlys[0];
                    } else {
                        this.introduceObj.quarterly = {
                            currencyType: introduceObjCurrencyType,
                            goodsPriceText: '58'
                        }
                    }
                    if(annuals.length) {
                        annuals.sort((a, b) => {
                            return b.goodsPriceText*1 - a.goodsPriceText*1;
                        });
                        this.introduceObj.annual = annuals[0];
                    } else {
                        this.introduceObj.annual = {
                            currencyType: introduceObjCurrencyType,
                            goodsPriceText: '198'
                        }
                    }
                    /*
                     * 计算会员介绍页面的季度和年度会员的价格
                     * */

                    res.data.dataList.sort((a, b) => {
                        return a.discountPrice*1 - b.discountPrice*1;
                    });
                    this.updateVipSelectRow = res.data.dataList[0];
                }
            });
        },
        appLogin({userCode, password,mvnoCode,loginType,channelType,partnerCode,langType,clientId,clientSecret}) {
            if(cookie.get('accessToken')) return;
            return this.$http.post({
                url:this.$api.quickUserLogin,
                data: {
                    "streamNo": this.$config.request.streamNoHead + (new Date()).getTime() + parseInt(Math.random() * 1000000),
                    "clientId": clientId||"xjh",
                    userCode,
                    password,
                    "randomId":'',
                    'clientSecret':clientSecret||'123456',
                    'mvnoCode':mvnoCode ||'GCGROUP',
                    "loginType": loginType || "PWD",
                    "channelType": channelType||  "APP",
                    "enterpriseCode": "",
                    "randomKey":"",
                    "langType": langType ||"zh-CN",
                    "partnerCode":partnerCode || "UKAPP",
                }
            }).then(res => {
                cookie.setCookies([
                    {
                        key : 'access_token',
                        value: res.accessToken
                    },
                    {
                        key: 'loginCustomerId',
                        value: res.userId
                    },
                    {
                        key: 'orgId',
                        value: res.orgId
                    },
                    {
                        key: 'mvnoCode',
                        value: res.mvnoCode || ''
                        //value: 'GlocM'
                    },
                    {
                        key: 'orgCode',
                        value: res.orgCode || ''
                    },
                    {
                        key: 'userId',
                        value: res.userId || ''
                    }
                ])
                return res
            })
        },
        webLoading() {
            // 判断是否允许访问H5
            /*if(this.$config.allow_access_to_h5) {
                window.dsBridge.call('WebLoading', true);
             } else {
                let keys = Object.keys(this.$config.app_info); // 本地配置的所有字段
                let has_value_keys = []; // 本地配置有值的字段集合
                if(keys.length > 0) {
                    let all_null = true; // 被配置字段是否全部设值
                    keys.forEach(key => {
                        if(this.$config.app_info[key]) {
                            has_value_keys.push(key);
                            all_null = false;
                        }
                    });
                    if(all_null) { // 配置的字段全部没有值，不允许访问
                        window.dsBridge.call('webLoading', false);
                    } else {
                        let app_info = JSON.parse(window.dsBridge.call('getInfo', 'AppMessage') || '{}');
                        let reg_num = 0; //配置字段有多少个匹配到
                        has_value_keys.forEach(key => {
                            if(this.$config.app_info[key] && app_info[key] && this.$config.app_info[key] === app_info) {
                                reg_num++;
                            }
                        });
                        if(reg_num == has_value_keys.length) { // 全部匹配到，满足不被允许访问条件
                            window.dsBridge.call('webLoading', false);
                        } else {
                            window.dsBridge.call('webLoading', true);
                        }
                    }
                 } else {
                    window.dsBridge.call('webLoading', false);
                }
             }*/
            if(this.$config.allow_access_to_h5) {
                window.dsBridge.call('WebLoading', true);
            } else {
                window.dsBridge.call('WebLoading', false);
            }
        },
        getOnlineTermimal() {
            this.$http.post({
                url: this.$api.queryOnlineTerminal
            }).then(res => {
                return res;
            })
        },
        queryCoverCountyInfo() {
            return this.$http.post({
                url: this.$api.queryCoverCountyInfo
            })
        },
        async getCountryName(code) {
           try {
               let res = await this.queryCoverCountyInfo();
               let countryName = res.data && res.data.find(item => item.iso2 == code.toUpperCase()).countryName;

               return countryName;
           } catch(err) {}
        },
        // 赠送流量包版本兼容
        giveSetVersionCompatible() {
            if(window.dsBridge.hasNativeMethod('toScan') && window.dsBridge.hasNativeMethod('bindByType')) {
                return true; // 兼容新版本
            } else {
                return false; // 不兼容新版本
            }
        }
    }
};

export const global = {
    app
};



// WEBPACK FOOTER //
// ./src/mixin/index.js